import React, { useEffect } from 'react'
import { trackEvent } from '@Utilities/marketingTags'
import { RtlPage, StickyBarClearance } from './CustomLanding.styled'
import Hero from './Components/Hero'
import TrustStats from './Components/TrustStats'
import AboutInstructor from './Components/AboutInstructor'
import SkillsGrid from './Components/SkillsGrid'
import PainPoints from './Components/PainPoints'
import MethodSteps from './Components/MethodSteps'
import ClassroomsCarousel from './Components/ClassroomsCarousel'
import FreeTrial from './Components/FreeTrial'
import ModernExam from './Components/ModernExam'
import ExperienceShot from './Components/ExperienceShot'
import Philosophy from './Components/Philosophy'
import FaqSection from './Components/FaqSection'
import FinalCta from './Components/FinalCta'
import StickyBar from './Components/StickyBar'

/* Tenant landing page for Mr Ibrahim Farid (tenant/mribrahimfarid branch):
   a port of the approved design pair (desktop + mobile artboards). Replaces
   GuestLanding for logged-out visitors; StudentLanding is untouched. */
const CustomLanding: React.FC = () => {
	useEffect(() => {
		trackEvent('ViewContent', { content_name: 'custom_landing', content_category: 'lander' })
	}, [])

	return (
		<RtlPage dir="rtl">
			<StickyBarClearance />
			<Hero />
			<TrustStats />
			<AboutInstructor />
			<SkillsGrid />
			<PainPoints />
			<MethodSteps />
			<ClassroomsCarousel />
			<FreeTrial />
			<ModernExam />
			<ExperienceShot />
			<Philosophy />
			<FaqSection />
			<FinalCta />
			<StickyBar />
		</RtlPage>
	)
}

export default CustomLanding
